const rankings = [
  { rank: 1, title: '社内恋爱法则', type: '韩漫', heat: '🔥 1280万热度', change: 'up' },
  { rank: 2, title: '重生之都市仙尊', type: '国漫', heat: '🔥 1156万热度', change: 'up' },
  { rank: 3, title: '咒术学院', type: '日漫', heat: '🔥 1089万热度', change: 'same' },
  { rank: 4, title: '极道千金', type: '韩漫', heat: '🔥 967万热度', change: 'up' },
  { rank: 5, title: '樱花树下的约定', type: '日漫', heat: '🔥 892万热度', change: 'down' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">人气排行</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            全网热度排行榜，看看本周最受欢迎的漫画
          </p>
        </div>

        <div className="space-y-3">
          {rankings.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-all"
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-lg font-heading text-lg flex-shrink-0 ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400 text-background-50' :
                item.rank === 3 ? 'bg-primary-300 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="font-heading text-base text-foreground-950 truncate">{item.title}</h3>
                  <span className="px-2 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-700 whitespace-nowrap">{item.type}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">{item.heat}</p>
              </div>
              <div className="flex-shrink-0">
                {item.change === 'up' && <i className="ri-arrow-up-line text-accent-500 text-lg"></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-primary-500 text-lg"></i>}
                {item.change === 'same' && <i className="ri-subtract-line text-foreground-400 text-lg"></i>}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a
            href="#cards"
            onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center text-sm text-primary-500 hover:text-primary-600 font-medium cursor-pointer whitespace-nowrap transition-colors"
          >
            查看完整榜单
            <i className="ri-arrow-right-line ml-1"></i>
          </a>
        </div>
      </div>
    </section>
  );
}